<template>
  <ul v-if="items.length">
    <main-sidebar-item-child
      v-for="(child, i) in mappedItems"
      :key="i"
      :component-props="child"
    />
  </ul>
</template>

<script setup lang="ts">
import { computed } from '@/composition/vue/compositionApi'
import type { PageContentSidebarItem } from '@/components/layout/pageContent/sidebar/types'
import MainSidebarItemChild, {
  type MainSidebarItemChildComponentProps,
} from '@/components/layout/mainSidebar/mainSidebarItemChild/MainSidebarItemChild.vue'
import TmAbsurdError from '@/core/error/tmAbsurdError'

const props = defineProps<{
  items: Array<PageContentSidebarItem>
  highlightExactActive?: boolean
}>()

const mappedItems = computed<MainSidebarItemChildComponentProps[]>(() =>
  props.items.map((t) => {
    if (t.itemType === 'group') {
      return {
        itemType: 'group',
        title: t.title,
      } satisfies MainSidebarItemChildComponentProps
    }
    if (t.itemType === 'groupCollapsible') {
      return {
        itemType: 'groupCollapsible',
        title: t.title,
        links: t.links,
      } satisfies MainSidebarItemChildComponentProps
    }
    if (t.itemType === 'link') {
      return {
        itemType: 'link',
        title: t.title,
        route: t.route,
        badge: t.badge,
        rightIcon: t.rightIcon,
        highlightExactActive: props.highlightExactActive,
      } satisfies MainSidebarItemChildComponentProps
    }

    throw new TmAbsurdError(t.itemType as never)
  }),
)
</script>
